export default "__VITE_ASSET__BCFwj1nz__"